class VideosCarousel extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.selector = '.videos-carousel__slider';
      this.videos = this.querySelectorAll('video');
      this.firstAutoEvent = false;
    }

    connectedCallback() {
      this.init();
      this.setupEventListeners();
    }

    init() {
      this.initSlider();
      this.playControls = this.querySelectorAll('.video-box__play-controls');
      this.soundControls = this.querySelectorAll('.video-box__sound');
    }

    setupEventListeners() {
      this.swiper.on('slideChange', this.handleSlideChange.bind(this));
      this.playControls.forEach(control => control.addEventListener('click', this.handlePlayControlClick.bind(this)));
      this.soundControls.forEach(control => control.addEventListener('click', this.handleSoundControlClick.bind(this)));
    }

    handlePlayControlClick(e) {
      const control = e.currentTarget;
      control.classList.toggle('active');
      this.togglePlay(control.closest('.video-box'));
    }

    handleSoundControlClick(e) {
      const control = e.currentTarget;
      control.classList.toggle('active');
      this.toggleSound(control.closest('.video-box'));
    }

    togglePlay(box) {
      const video = box.querySelector('video');
      this.pauseAll(video);
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }

    toggleSound(box) {
      const video = box.querySelector('video');
      video.muted = !video.muted;
    }

    pauseAll(exception) {
      this.videos.forEach(video => {
        if (video !== exception && !video.paused) {
          video.pause();
          video.closest('.video-box').querySelector('.video-box__play-controls').classList.toggle('active');
        }
      })
    }

    handleSlideChange() {
      if (!this.firstAutoEvent) {
        return this.firstAutoEvent = true;
      };
      const slider = this.swiper;
      const slides = slider.slides; 
      let activeSlide = window.innerWidth > 1024 ? slides[slider.activeIndex + 2] : slides[slider.activeIndex];

      const activeVideo = activeSlide.querySelector('video');
      this.pauseAll(activeVideo);
      activeVideo.play();
      activeSlide.querySelector('.video-box__play-controls').classList.add('active');
    }

    initSlider() {
      const swiper = this.swiper = new Swiper(this.selector, {
        effect: "coverflow",
        navigation: {
          nextEl: '.videos-next-button',
          prevEl: '.videos-prev-button'
        },
        // loopAdditionalSlides: 4,
        // loopedSlides: 4,
        loop: true,
        initialSlide: 1,
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            centeredSlides: true,
            spaceBetween: 10,
            coverflowEffect: {
              rotate: 0,
              stretch: 0,
              
              depth: 0,
              scale: 0.9,
              
              modifier: 1,
              slideShadows: false
            },
          },
          768: {
            slidesPerView: 4,
            
            centeredSlides: false,  
            
            spaceBetween: 10,
            coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: 0,
              scale: 0.9,
              modifier: 1,
              slideShadows: false
            },
          },
          1024: {
            slidesPerView: 6,
            centeredSlides: false,  
            spaceBetween: 18,
            coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: 0,
              scale: 0.9,
              modifier: 1,
              slideShadows: false
            },
          }
        }
      });  
    }
  }
  
  if (!window.customElements.get("videos-carousel")) {
    window.customElements.define("videos-carousel", VideosCarousel);
  }
